module.exports = new __parcel__URL__("smartsheet-logomark-darkmode.c171c7c9.svg").toString();